import { Link } from "react-router-dom";
import React from "react";

const FacilityManagementMenu = ({ token, username, isActive, onToggle }) => {
  // Check if user has facility management module and appropriate role
  if (username.bedrijf && username.bedrijf.modules && username.bedrijf.modules.includes("facility-management")) {
    if (token.role === "admin" || token.role === "manager" || token.role === "medewerker" || token.role === "faciliteitmedewerker") {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon">
              <i className="fas fa-tools"></i>
            </span>
            <span className="menu-text">Facility Management</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}>
              <i className="fas fa-chevron-right"></i>
            </span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/facility" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-tachometer-alt"></i>
                </span>
                <span className="menu-text">Dashboard</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/facility/storingen" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-exclamation-triangle"></i>
                </span>
                <span className="menu-text">Storingen</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/facility/werkorders" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-tasks"></i>
                </span>
                <span className="menu-text">Werkorders</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/facility/accommodaties" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-home"></i>
                </span>
                <span className="menu-text">Accommodaties</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/facility/categories" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-tags"></i>
                </span>
                <span className="menu-text">Categorieën</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/facility/rapportages" className="menu-link">
                <span className="menu-icon">
                  <i className="fas fa-chart-bar"></i>
                </span>
                <span className="menu-text">Rapportages</span>
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export default FacilityManagementMenu;